import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/i18n/TranslationContext';
import { LanguageToggle } from '@/components/layout/LanguageToggle';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background vrs-grid relative flex items-center justify-center p-6" data-testid="not-found-page">
      <div className="absolute top-4 right-4 z-50">
        <LanguageToggle />
      </div>
      <div className="text-center space-y-6">
        <div className="flex items-center justify-center gap-3 mb-4">
          <Shield className="h-10 w-10 text-primary" />
        </div>
        <h1 className="text-6xl font-bold font-mono text-foreground">404</h1>
        <p className="text-lg text-muted-foreground">{t('page_not_found')}</p>
        <p className="text-sm text-muted-foreground max-w-md">The page you're looking for doesn't exist or has been moved.</p>
        <div className="flex items-center justify-center gap-3 pt-4">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" />Go Back
          </Button>
          <Button onClick={() => navigate('/dashboard')}>
            <Home className="mr-2 h-4 w-4" />Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
